export const dataHandlers = {
  font: (data, canvas, customProps) => {
    const font = JSON.parse(data);
   
    const text = new fabric.Textbox(font.name ||font.family || font.font_family, {
      fontFamily: font.family || font.font_family || font.name  ,
      left: customProps?.left ?? 100,
      top: customProps?.top ?? 100,
      originX: "center",
      originY: "center",
      fontSize: 50,
    });
    
    canvas.add(text);
    canvas.renderAll();
  },
  image: (data, canvas, customProps) => {
    return new Promise((resolve, reject) => {
      try {
        fabric.Image.fromURL(data, (img) => {
          img.scaleToHeight(400);
          img.set({
            left: customProps?.left ?? 100,
            top: customProps?.top ?? 100,
            // scaleX: 0.5,
            // scaleY: 0.5,
            originX: "center",
            originY: "center",
          });
          canvas.add(img);
          canvas.renderAll();
          resolve(img);
        },{ crossOrigin: "anonymous" });
      } catch (err) {
        reject(err?.message);
      }
    });
  },

svg: (data, canvas, customProps) => {
  // Define a default size. You can separate these if needed.
  const defaultSize = 400;
  
  fabric.loadSVGFromURL(data, (objects, options) => {
    const svgGroup = fabric.util.groupSVGElements(objects, options);

    // Optionally, set explicit width/height properties on the group.
   
    svgGroup.set({
      left: customProps?.left ?? defaultSize,
      top: customProps?.top ?? defaultSize,
      originX: "center",
      originY: "center",
    }).setCoords();

   
    svgGroup.scaleToHeight(defaultSize);
    canvas.add(svgGroup);
    canvas.renderAll();
  });
  
},

svgFile: (file, canvas, customProps = {}) => {
  // This method is for loading SVGs from an uploaded file (file object)
  if (!file) return;
  const reader = new FileReader();
  reader.onload = function (e) {
    const svgString = e.target.result; // SVG content as a string
    fabric.loadSVGFromString(svgString, (objects, options) => {
      const group = fabric.util.groupSVGElements(objects, options);
      const defaultSize = 400;
   
      group.set({
        left: customProps.left ?? defaultSize,
        top: customProps.top ?? defaultSize,
        originX: "center",
        originY: "center",
      }).setCoords();
      group.scaleToHeight(defaultSize);
      canvas.add(group);
      canvas.renderAll();
    });
  };
  reader.readAsText(file);
},

};

